import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const opts = [0, 1, 1.5, 2, 2.5, 3, 4, 5] as number[];

export const optFormatter = (n: number | string): React.JSX.Element => <FormattedMessage id={'updrs.opts.v.' + n} />;
